"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _companyappApi = require("@/api/companyappApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'AuditMediaUpload',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    companyAppId: {
      type: Number,
      required: true
    },
    purpose: {
      type: String,
      required: true
    },
    limit: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      uploadingUids: [],
      files: []
    };
  },
  computed: {
    isVideo: function isVideo() {
      return this.purpose === 'preview_video';
    },
    maxMegabytes: function maxMegabytes() {
      return this.isVideo ? 20 : this.purpose === 'feedback_image' ? 2 : 5;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(ids) {
        var _this = this;
        var current = this.files.filter(function (item) {
          return item.status === 'success';
        }).map(function (item) {
          return item.response.mediaId;
        });
        if (JSON.stringify(current) === JSON.stringify(ids)) return;
        var pending = this.files.filter(function (item) {
          return item.status === 'ready' || item.status === 'uploading';
        });
        this.files = ids.map(function (id, index) {
          return _this.files.find(function (item) {
            return item.response && item.response.mediaId === id;
          }) || {
            uid: "saved-".concat(id),
            name: "\u5386\u53F2".concat(_this.isVideo ? '录屏' : '图片').concat(index + 1, "\uFF08\u7D20\u6750ID\uFF1A").concat(id, "\uFF09"),
            status: 'success',
            response: {
              mediaId: id
            }
          };
        }).concat(pending);
      }
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var valid = this.isVideo ? /\.mp4$/i.test(file.name) : /\.(jpe?g|png|bmp|gif)$/i.test(file.name);
      if (!valid) {
        this.$message.warning(this.isVideo ? '提审录屏仅支持mp4格式' : '图片仅支持jpg、jpeg、png、bmp、gif格式');
        return false;
      }
      if (!file.size || file.size > this.maxMegabytes * 1024 * 1024) {
        this.$message.warning("\u8BF7\u9009\u62E9\u975E\u7A7A\u4E14\u4E0D\u8D85\u8FC7".concat(this.maxMegabytes, "MB\u7684\u6587\u4EF6"));
        return false;
      }
      return true;
    },
    upload: function upload(options) {
      var _this2 = this;
      var data = new FormData();
      data.append('companyAppId', this.companyAppId);
      data.append('purpose', this.purpose);
      data.append('file', options.file);
      var uid = options.file.uid;
      this.uploadingUids.push(uid);
      var complete = function complete() {
        _this2.uploadingUids = _this2.uploadingUids.filter(function (item) {
          return item !== uid;
        });
      };
      // 将 Promise 交给 el-upload 更新状态，不能再手动 onSuccess，否则会回调两次并覆盖素材ID。
      return (0, _companyappApi.uploadMiniProgramAuditMediaApi)(data).then(function (result) {
        complete();
        return result;
      }, function (error) {
        complete();
        throw error;
      });
    },
    beforeRemove: function beforeRemove(file) {
      if (this.uploadingUids.includes(file.uid)) {
        this.$message.warning('请等待该素材上传完成后再删除');
        return false;
      }
      return !this.disabled;
    },
    handleChange: function handleChange(file, fileList) {
      this.files = fileList.slice();
      this.$emit('input', fileList.filter(function (item) {
        return item.status === 'success' && item.response && item.response.mediaId;
      }).map(function (item) {
        return item.response.mediaId;
      }));
      this.$emit('busy-change', fileList.some(function (item) {
        return item.status === 'ready' || item.status === 'uploading';
      }));
    },
    handleExceed: function handleExceed() {
      this.$message.warning("\u6700\u591A\u4E0A\u4F20".concat(this.limit, "\u4E2A\u6587\u4EF6\uFF0C\u8BF7\u5148\u5220\u9664\u5DF2\u6709\u6587\u4EF6\u518D\u4E0A\u4F20"));
    }
  }
};